var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"state-resource-chart"},[_c('div',{staticClass:"state-resource-chart-title"},[_c('div',{staticClass:"name"},[_vm._v("学段资源建设分布")])]),_c('div',{staticClass:"chart",attrs:{"id":"stateResourceChartId"}})])
}]

export { render, staticRenderFns }